export default __webpack_public_path__ + "static/media/map-hover.3e774ab5.svg";